const actions = {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_ERROR: 'RESET_PASSWORD_ERROR',
  RESET_PASSWORD_CONFIRM: 'RESET_PASSWORD_CONFIRM',
  RESET_PASSWORD_CONFIRM_SUCCESS: 'RESET_PASSWORD_CONFIRM_SUCCESS',
  RESET_PASSWORD_CONFIRM_ERROR: 'RESET_PASSWORD_CONFIRM_ERROR',
  GOOGLE_LOGIN_REQUEST: 'GOOGLE_LOGIN_REQUEST',
  ACCESS_NOT_FOUND: 'ACCESS_NOT_FOUND',
  CLOSE_ACCESS_NOT_FOUND: 'CLOSE_ACCESS_NOT_FOUND',
  LOGOUT: 'LOGOUT',
  LOGOUT_SUCCESS: 'LOGIN_LOGOUT',
  
  login: credentials => ({
    type: actions.LOGIN_REQUEST,
    payload: { credentials },
  }),

  // accessToken: Google access token; profile: { email, name, picture } from Google (best effort).
  googleLogin: (accessToken, profile = {}) => ({
    type: actions.GOOGLE_LOGIN_REQUEST,
    payload: { accessToken, profile },
  }),

  // The Google e-mail is not one of ours: opens the "not found" modal.
  accessNotFound: profile => ({
    type: actions.ACCESS_NOT_FOUND,
    payload: { profile },
  }),

  closeAccessNotFound: () => ({
    type: actions.CLOSE_ACCESS_NOT_FOUND,
  }),

  loginSuccess: data => ({
    type: actions.LOGIN_SUCCESS,
    payload: data,
  }),

  loginError: error => ({
    type: actions.LOGIN_ERROR,
    payload: { error },
  }),

  resetPassword: credentials => ({
    type: actions.RESET_PASSWORD_REQUEST,
    payload: { credentials },
  }),

  resetPasswordSuccess: data => ({
    type: actions.RESET_PASSWORD_SUCCESS,
    payload: data,
  }),

  resetPasswordError: error => ({
    type: actions.RESET_PASSWORD_ERROR,
    payload: { error },
  }),

  resetPasswordConfirm: credentials => ({
    type: actions.RESET_PASSWORD_CONFIRM,
    payload: { credentials },
  }),

  resetPasswordConfirmSuccess: data => ({
    type: actions.RESET_PASSWORD_CONFIRM_SUCCESS,
    payload: data,
  }),

  resetPasswordConfirmError: error => ({
    type: actions.RESET_PASSWORD_CONFIRM_ERROR,
    payload: { error },
  }),

  logout: () => ({
    type: actions.LOGOUT,
  }),

  logoutSuccess: () => ({
    type: actions.LOGOUT_SUCCESS,
  })
};

export default actions;
